import React from 'react';

// The CANONICAL messaging-consent body bound to MESSAGING_CONSENT_VERSION (v2-2026-08).
// SINGLE SOURCE OF TRUTH — rendered verbatim at the agreement step
// (ContributionAgreementScreen) AND in the re-consent modal (ReconsentModal), so the
// text a member agrees to is identical everywhere and can never drift. If this wording
// changes, bump MESSAGING_CONSENT_VERSION. Finalized copy (Frannie).
const MessagingConsentText = ({ className = 'text-sm text-neutral-600 leading-relaxed' }) => (
  <p className={className}>
    By joining, you agree to let EsuSol keep you posted on your savings circle. We'll send your
    verification code, payment updates, and account alerts by SMS and WhatsApp at the number you
    give us. Standard message and data rates may apply. Reply STOP anytime to opt out. See our{' '}
    <a href="/terms.html" target="_blank" rel="noopener noreferrer" className="text-primary-600 underline hover:text-primary-700">Terms</a>{' '}
    and{' '}
    <a href="/privacy.html" target="_blank" rel="noopener noreferrer" className="text-primary-600 underline hover:text-primary-700">Privacy Policy</a>.
  </p>
);

export default MessagingConsentText;
